<template>
    <div>
        <modal-dialog title="Sign in to your account" classes="modal--centered" :show="show" @close="close">
            <div class="text-center">
                <p>If you have an account please sign in<br> <em>or</em> checkout quickly as a guest.</p>
            </div>
            <hr>

            <div class="row">
                <div class="col-md-6">
                    <button class="btn btn-sm btn-grey btn--full-width" @click="cancel">
                        <template v-if="checkout">
                            Checkout as guest
                        </template>
                        <template v-else>
                            Cancel
                        </template>
                    </button>
                </div>
                <div class="col-md-6 text-right">
                    <a href="/login" class="btn btn-sm btn-blue btn--full-width" rel="nofollow" v-if="showRegister">Register</a>
                    <button @click="signin" class="btn btn-green btn-sm btn--full-width">Sign in</button>
                </div>
            </div>
        </modal-dialog>
        <login-modal :show="showLogin" @loggedin="loggedin"></login-modal>
    </div>
</template>

<script>
    import ModalDialog from '../ModalDialog.vue';
    import LoginModal from './LoginModal.vue';

    export default {
        components: {
            ModalDialog,
            LoginModal,
        },
        props: {
            checkout: {
                type: Boolean,
                default: false,
            },
            show: {
                type: Boolean,
                default: false,
            },
            showRegister: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                showLogin: false
            }
        },
        methods: {
            signin() {
                this.showLogin = !this.showLogin;
            },
            close() {
                this.$emit('close', true);
            },
            loggedin() {
                if (this.checkout) {
                    window.location = '/checkout';
                } else {
                    this.showLogin = false;
                    this.$emit('loggedin', true);
                }
            },
            /**
             * Cancel the login
             */
            cancel() {
                this.$emit('guest', true);
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/Modals/GuestOrAccountModal.vue